
import Vue from  'vue';

export default {

    methods: {

        _onClick(event)
        {
            this.$emit('click', event)
        }
    }
}
